import Api from 'libs/api';

class CompaniesApi extends Api {
  constructor() {
    super('admin/companies');
  }

  getStripeLink = (companyId) => {
    return this.buildQuery('get', {}, `${companyId}/stripe_onboarding`);
  }

  getStripeLoginLink = (companyId) => {
    return this.buildQuery('get', {}, `${companyId}/stripe_login_link`);
  }
}

export default CompaniesApi;
